import globalAgent from 'src/agent';
import qs from 'qs';
import { URLS } from 'src/constants/urls';

import { StatsHighlights, DailyStatsResponse } from 'src/types/Stats';

import type { AxiosPromise } from 'axios';

export const getStatsHighlights = (): AxiosPromise<StatsHighlights> => {
    return globalAgent.get(`${URLS.MESSAGES}stats/messages/highlights/`);
};

export const getDailyStats = (params: {
    from: string;
    to: string;
    relevant_only?: boolean;
}): AxiosPromise<DailyStatsResponse> => {
    const _params = qs.stringify({ ...params }, { skipNulls: true, addQueryPrefix: true });
    return globalAgent.get(`${URLS.MESSAGES}stats/messages/daily${_params}`);
};

export const getDailyLeadsStats = (params: {
    from: string;
    to: string;
    streams?: number[];
}): AxiosPromise<DailyStatsResponse> => {
    const _params = qs.stringify({ ...params }, { skipNulls: true, addQueryPrefix: true });
    return globalAgent.get(`${URLS.MESSAGES}stats/leads/daily${_params}`);
};
